<mat-form-field class="form-full-width" appearance="outline"
                    [formGroup]="service.group"
                    [class.load-spinner-select]="service.isShowSpinner | async"
                    [class.remove-option-select-field]="service.group?.get(service.field.name)?.value
 && service.fieldValue[service.group.get(service.field.name).value]
  && (service.fieldValue[service.group.get(service.field.name).value].is_del == true || service.fieldValue[service.group.get(service.field.name).value].is_del == '1')">
        <i matPrefix *ngIf="service.field?.leadingIcon" [ngClass]="'mdi mdi-' + service.field?.leadingIcon" class="select_leading-icon"></i>
        <mat-label>{{service.field.label}}</mat-label>
        <mat-progress-spinner *ngIf="service.isShowSpinner | async"
                              matSuffix color="primary" mode="indeterminate"
                              diameter="18">
        </mat-progress-spinner>
        <fui-button
            class="select_trailing-button"
            icon="chevron-down"
            type="button-icon"
            height="mini"
            borderRadius="circle"
            color="neutral"
            [disabled]="service.field.disabled">
        </fui-button>
        <mat-select #matSelect
                    [formControl]="service.group.get(service.field.name)"
                    [panelClass]="service.options.length > appService.hideSelectOptions ? '' : 'not-padding-mat-select-search-panel'"
                    [multiple]="service.field.multiple"
                    [disableOptionCentering]="true">
            <ng-container *ngIf="service.options.length > appService.hideSelectOptions">
                <mat-option class="search-option"
                            [class.select-search-option-empty]="(filteredSelect | async)?.length === 0">
                    <ngx-mat-select-search [disableInitialFocus]="!deviceService.isDesktop()"
                                           [formControl]="filterCtrl"
                                           [cdkTrapFocus]="false"
                                           [showToggleAllCheckbox]="service.field.multiple"
                                           (toggleAll)="toggleSelectAll($event)"
                                           [toggleAllCheckboxChecked]="toggleAllCheckboxChecked()"
                                           [toggleAllCheckboxIndeterminate]="toggleAllCheckboxIndeterminate()"
                                           placeholderLabel="{{appService.language_dictionary.system_search}}"
                                           noEntriesFoundLabel="{{appService.language_dictionary.system_no_options_found}}"
                                           [clearSearchInput]="true">
                        <fui-button
                            [title]="appService.language_dictionary.system_clear"
                            ngxMatSelectSearchClear
                            icon="close"
                            type="button-icon"
                            color="neutral"
                            height="mini"
                            borderRadius="circle"
                            iconSize="20">
                        </fui-button>
                    </ngx-mat-select-search>
                </mat-option>
            </ng-container>
            <mat-option [value]=""
                        *ngIf="!service.field.multiple && !service.field.required"
                        (click)="service.group.get(service.field.name).setValue(null)">
                {{appService.language_dictionary.system_not_specified_upp_case}}
            </mat-option>
            <!-- Опция для загрузки данных -->
            <ng-container>
                    <div fxLayout="row"
                         *ngFor="let option of filteredSelect | async">
                        <mat-option
                            [fxFlex]="(option.is_del == true || option.is_del == '1') ? '1 1 calc(100% - 50px)' : '1 1 100%'"
                            [disabled]="option?.is_del == '1'"
                            [value]="option.id"
                            [class.add-tree-hyphen]="service.field.addTreeHyphen"
                            [class.remove-option-select]="(option.is_del == true || option.is_del == '1')">
                            {{getOptionName(option)}}
                        </mat-option>
                        <div fxFlex="1 1 50px"
                             *ngIf="(option.is_del == true || option.is_del == '1')" class="remove-option-title">
                            {{appService.language_dictionary.deleted}}
                        </div>
                    </div>
            </ng-container>
        </mat-select>
        <ng-container *ngFor="let validation of service.field?.validations;" ngProjectAs="mat-error">
            <mat-error *ngIf="service.group?.get(service.field.name)?.hasError(validation.name)"
                       [innerHTML]="validation.name == 'serverError' ? service.group?.get(service.field.name)?.errors?.serverError : validation.message">
            </mat-error>
            <mat-error *ngIf="service.group?.get(service.field.name)?.hasError('pattern') && service.group?.get(service.field.name)?.hasError('required')">
                Your selection is invalid
            </mat-error>
        </ng-container>
        <mat-hint *ngIf="this.service.field.hint" [innerHtml]="this.service.field.hint" [ngClass]="'select_tooltip'" [title]="this.service.field.hint"></mat-hint>
    </mat-form-field>
